import React, { FunctionComponent } from "react"
import ReactPlayer from "react-player"
import "react-slideshow-image/dist/styles.css"
import "./gallery.css"

interface iProps {
  onShowVideo: () => void
  url: string
}

const VideoOverlay: FunctionComponent<iProps> = ({ onShowVideo, url }) => {
  return (
    <div className="gallery_holder">
      <ReactPlayer url={url} />

      <div
        className="gallery_close"
        onClick={() => {
          onShowVideo()
        }}
      >
        <img src={window.location.origin + "/icons/close.png"} alt="" />
      </div>
    </div>
  )
}

export default VideoOverlay
